import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export default function FinalCTA({ onBookService }) {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-14 sm:py-20 lg:py-24 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-brand-blue via-brand-blue-light to-brand-green" />
      <div aria-hidden className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-white/10 blur-3xl" />
      <div aria-hidden className="absolute -bottom-10 -left-10 w-72 h-72 rounded-full bg-brand-green/40 blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 text-center text-white">
        <h2
          className="text-2xl sm:text-4xl lg:text-5xl font-bold leading-tight"
          style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
          data-testid="final-cta-title"
        >
          Get Rid of Pests Today!
        </h2>
        <p className="mt-3 sm:mt-4 text-base sm:text-lg text-white/85 max-w-xl mx-auto">
          Book a professional service in minutes. Same-day appointments available.
        </p>

        <div className="mt-7 sm:mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center sm:items-center">
          <a
            href="tel:+917819988010"
            data-testid="final-call-btn"
            className="inline-flex items-center justify-center gap-2 h-12 sm:h-14 px-7 rounded-full bg-white text-brand-blue font-semibold shadow-lg hover:bg-white/95 transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            <Phone size={18} />
            Call Now
          </a>
          <Button
            onClick={onBookService}
            data-testid="final-book-btn"
            className="h-12 sm:h-14 px-7 rounded-full bg-brand-green hover:bg-brand-green-dark text-white font-semibold shadow-lg shadow-black/10 transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            Book Service Now
            <ArrowRight className="ml-2" size={18} />
          </Button>
        </div>
      </div>
    </section>
  );
}
